import React from "react";

const Safty = () => {
  return <div>This is safety Components</div>;
};

export default Safty;
